import { Transition } from "@headlessui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { faClone } from "@insidebeehive/fortawesome/pro-solid-svg-icons/faClone";

import { Icon } from "../ui/icon";

/**
 *This is react component used as text copy tool in transactions table
 *
 * @param {*} { children }
 * @return {*}
 */
const TextCopyTool: React.FC<any> = ({ children }: any) => {
  const { t } = useTranslation("common");
  const [show, setShow] = useState<boolean>(false);

  const [check, setCheck] = useState<boolean>(false);

  const copyHandler = () => {
    setCheck(true);
    setShow(!show);
    navigator.clipboard.writeText(children);
    setTimeout(() => {
      setShow(false);
    }, 3000);
    setTimeout(() => {
      setCheck(false);
    }, 3000);
  };

  return (
    <div className="inline-block relative">
      <div className="w-fit cursor-pointer font-semibold text-gray-800 px-2 py-0 text-sm flex relative transition-transform ease-out duration-1000 z-0">
        {check ? (
          <span title={t("copyTool.copy")} className="z-0">
            <Icon onClick={copyHandler} icon={faClone} name="clone-solid" className="text-lg text-green-400 w-4 h-4 hover:text-green-400 z-0" />
          </span>
        ) : (
          <Transition show={!show} enter="transition-opacity duration-500" enterFrom="opacity-0" enterTo="opacity-100" leave="transition-opacity duration-500" leaveFrom="opacity-100" leaveTo="opacity-0">
            <span title={t("copyTool.copyText")} className="z-0">
              <Icon onClick={copyHandler} icon={faClone} name="clone-solid" className="text-gray-300 hover:text-green-400 w-4 h-4 z-0" />
            </span>
          </Transition>
        )}
      </div>

      <Transition show={show} enter="transition-opacity duration-1000" enterFrom="opacity-100" enterTo="opacity-100" leave="transition-opacity duration-500" leaveFrom="opacity-100" leaveTo="opacity-10">
        {/* Will fade in and out */}
        <div className="absolute left-full top-1/2 -translate-y-1/2 ml-1 z-50 flex items-center">
          <span className="p-1.5 text-xs leading-none text-white whitespace-nowrap bg-green-500 shadow-lg rounded-md">{t("copyTool.copied")}</span>
        </div>
      </Transition>
    </div>
  );
};

export default TextCopyTool;
